import {Injectable} from "@angular/core";
import {CanDeactivate} from "@angular/router";
import {LeavePageInterface} from "../interfaces/leave-page.interface";
import {Observable, of, switchMap} from "rxjs";
import {EdModalsService} from "@edenred/components/modals";
import {CancelPromptComponent} from "../cancel-prompt.component";

@Injectable({
	providedIn: 'root'
})
export class UnsavedChangesGuard implements CanDeactivate<LeavePageInterface> {

	constructor(private modalService: EdModalsService) {
	}

	canDeactivate(component: LeavePageInterface): boolean | Observable<boolean> {
		return component.canLeave() ? true :
				this.modalService.open(CancelPromptComponent, {disableCloseOnBackdrop: true}).afterClosed.pipe(
						switchMap((result) => {
							return of(<boolean>result);
						}));
	}
}